export const redirectToLoginForExpiredSession = () => {
  if (window.location.pathname === "/login") return

  localStorage.setItem("redirectAfterLogin", window.location.pathname)
  localStorage.removeItem("loggedIn")
  window.location.assign("/login?reason=expired")
}
